import '../css/app.css';
import $ from 'jquery';
import sliders from './modules/sliders';
import navigation from './modules/navigation';

window.$ = $;
window.jQuery = $;


$(document).ready(function($) {

  let $accounts = [
    {
      'account': '5526934438',
      'accessToken': '5526934438.1677ed0.40f12d234eaf41408215a8d82777ffdb'
    },
    {
      'account': '5665817127',
      'accessToken': '5665817127.1677ed0.e482c610586a49ff8aaf8366a1ab3100'
    }
  ];

  sliders();
  navigation();

});








// WEBPACK FOOTER //
// ./assets/js/app.js